import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { FALLBACK_BRANDS } from "@/lib/brand-data";

const PartnersMarquee = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["brandShowcases"],
    queryFn: api.cms.brandShowcases,
    staleTime: 5 * 60 * 1000,
  });

  const cmsBrands = data?.brands ?? [];
  const brands = cmsBrands.length > 0 ? cmsBrands : [...FALLBACK_BRANDS];

  // Show skeleton placeholders while loading
  if (isLoading) {
    return (
      <section className="py-10 bg-muted/40 border-y border-border overflow-hidden">
        <div className="container-max px-5 sm:px-8 lg:px-12 mb-6">
          <p className="text-center text-xs uppercase tracking-[0.15em] text-muted-foreground font-semibold">
            Nos Marques
          </p>
        </div>
        <div className="flex gap-6 sm:gap-10 md:gap-16 items-center justify-center px-8">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 animate-pulse">
              <div className="h-10 w-10 md:h-12 md:w-12 rounded-full bg-muted" />
              <div className="h-4 w-24 rounded bg-muted" />
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (brands.length === 0) return null;

  // Triple the list for smooth infinite scroll
  const items = [...brands, ...brands, ...brands];

  return (
    <section className="py-10 bg-muted/40 border-y border-border overflow-hidden">
      <div className="container-max px-5 sm:px-8 lg:px-12 mb-6">
        <p className="text-center text-xs uppercase tracking-[0.15em] text-muted-foreground font-semibold">
          Nos Marques
        </p>
      </div>
      <div className="relative">
        <div className="marquee-track flex gap-6 sm:gap-10 md:gap-16 items-center whitespace-nowrap">
          {items.map((brand, i) => (
            <div
              key={`${brand.id}-${i}`}
              className="flex-shrink-0 flex items-center gap-3"
            >
              {brand.logo_url ? (
                <img
                  src={brand.logo_url}
                  alt={brand.brand_name}
                  className="h-10 md:h-12 w-auto object-contain"
                  loading="lazy"
                />
              ) : brand.cover_image_url ? (
                <img
                  src={brand.cover_image_url}
                  alt={brand.brand_name}
                  className="h-10 md:h-12 w-auto object-contain"
                  loading="lazy"
                />
              ) : (
                <div
                  className="h-10 md:h-12 w-10 md:w-12 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: `${brand.accent_color}30` }}
                >
                  <span className="text-lg font-display font-bold" style={{ color: brand.accent_color }}>
                    {brand.brand_name.charAt(0)}
                  </span>
                </div>
              )}
              <span className="text-muted-foreground/50 font-bold text-base md:text-lg font-display tracking-wide">
                {brand.brand_name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersMarquee;
